import React, {useState, useEffect} from "react";
import {useTitleFromComponent, useDataWithRoute} from "../../../utils/hooks";
import {useVsiAppContext} from "../../../stores/VsiApp";
import TreeMap from "../../../components/TreeMap";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import Grid from "../../../components/Grid";
import {cloudGrowthOverview} from "../../../utils/gridColumnDefs/cloud/cloudGrowthOverview";
import themeStyles, {vsiGreen} from "../../../utils/themeStyles";
import {Card} from "reactstrap";

export default function CloudGrowthOverview({context, title}) {
    useTitleFromComponent(`${context} / ${title}`);
    const { theme, client, periodId } = useVsiAppContext();

    const [treeData, setTreeData] = useState([]);
    const [totalCost, setTotalCost] = useState('');

    // const [data] = useMockDataWithRoute(`/api/mock/cloud_growth_overview`);
    const [data] = useDataWithRoute(`/api/v6/report/enterprise_cloud_proc?client_id=${client.clientId}&period_id=${periodId}`);

    const determineColor = val => {
        const newVal = val * 100;

        // const nums = [5, 10, 20, 30, 40];
        //
        // let color = heatColorsSoft[0];
        // for (let i = 0; i < nums.length; i++) {
        // 	if (i !== nums.length - 1) {
        // 		if (newVal < nums[i]) {
        // 			color = heatColorsSoft[i];
        // 		}
        // 	}
        // }

        // return color;
        if (newVal >= 5) {
            return '#e10000';
        } else if (newVal >= 0 && newVal < 5) {
            return 'grey'
        } else {
            return vsiGreen;
        }
    }

    const formatTreeData = (data) => {
        const resourcesDict = {};

        const allVms = data.map((datum, index) => {
            if (!resourcesDict[datum.resource_group]) {
                resourcesDict[datum.resource_group] = `id_${datum.resource_group}_${index}`;
            }

            return {
                id: `id_${datum.resource_name}_${index}`,
                name: `${datum.resource_name}`,
                value: parseFloat(datum.total_cost.toFixed(2)),
                color: determineColor(datum.growth),
                parent: resourcesDict[datum.resource_group],
            }
        });

        const allResources = Object.keys(resourcesDict).map(key => {
            return {
                name: key,
                id: resourcesDict[key],
            }
        });
        return [...allResources, ...allVms];
    };

    const filterChanged = (eventData) => {
        let rowData = [];
        eventData.api.forEachNodeAfterFilter(node => {
            rowData.push(node.data);
        });

        const sortedData = rowData.sort((a, b) => {
            return new Date(a.collection_date) - new Date(b.collection_date)
        }) || [];

        setTotalCost(sortedData.reduce((accum, val) => {
            return accum + val.total_cost
        }, 0).toFixed(2))
        setTreeData(formatTreeData(sortedData));

    }

    useEffect(() => {
        setTotalCost((data?.recordsets?.[0] || []).reduce((accum, val) => {
            return accum + val.total_cost
        }, 0).toFixed(2));
        setTreeData(formatTreeData(data?.recordsets?.[0] || []));
    }, [data?.recordsets]);

    return <Card className={`report-card p-2 nav-card-${theme}`}>
        <VsiH4>Cloud Growth Overview</VsiH4>
        <VsiBubble>
            <TreeMap series={[{
                levels: [{
                    level: 1,
                    borderWidth: 5,
                    dataLabels: {
                        enabled: true,
                        align: 'left',
                        verticalAlign: 'top',
                        color: themeStyles?.[theme]?.textColor,
                        style: {
                            color: '#FFFFFF',
                            fontWeight: 'bold',
                            fontSize: '1.3rem',
                        }
                    }
                }, {
                    level: 2,
                    layoutAlgorithm: 'squarified',

                    dataLabels: {
                        enabled: true,
                        align: 'center',
                        verticalAlign: 'middle',
                        color: themeStyles?.[theme]?.textColor,
                        fontSize: '3rem',
                        style: {
                            color: '#FFFFFF',
                            fontWeight: 'bold',
                            fontSize: '.9rem',
                        }
                    }
                }],
                data: treeData
            }]}
                     title={totalCost ? `Total Cost: $${totalCost}` : null}/>
        </VsiBubble>
        <VsiBubble>
            <Grid addStyle
                  filterChanged={filterChanged}
                  data={data?.recordsets?.[0] || []}
                  columnDefs={cloudGrowthOverview}/>
        </VsiBubble>
    </Card>
}
